import { render, staticRenderFns } from "./CategoryComponent.vue?vue&type=template&id=08a93246&"
import script from "./CategoryComponent.vue?vue&type=script&lang=ts&"
export * from "./CategoryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports